import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import logo from '../assets/logo.svg';
import './Header.css';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showLogo, setShowLogo] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setShowLogo(scrollPosition > 200);
    };

    // Check initial scroll position
    handleScroll();

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.header 
      className="header"
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.4, 0, 0.2, 1] }}
    >
      <div className="header-container">
        <motion.div
          whileHover={{ scale: 1.02, y: -1 }}
          transition={{ duration: 0.3 }}
        >
          <Link to="/" className="header-logo">
            <AnimatePresence mode="wait">
              {showLogo ? (
                <motion.img
                  key="logo"
                  src={logo}
                  alt="marie mercier"
                  className="header-logo-image"
                  initial={{ scale: 0.8, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  exit={{ scale: 0.8, opacity: 0 }}
                  transition={{
                    duration: 0.6,
                    ease: [0.4, 0, 0.2, 1]
                  }}
                />
              ) : (
                <motion.span
                  key="text"
                  className="header-logo-text"
                  initial={{ scale: 0.8, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  exit={{ scale: 0.8, opacity: 0 }}
                  transition={{
                    duration: 0.6,
                    ease: [0.4, 0, 0.2, 1]
                  }}
                >
                  Marie Mercier
                </motion.span>
              )}
            </AnimatePresence>
          </Link>
        </motion.div>
        <nav className={`header-nav ${isMenuOpen ? 'open' : ''}`}>
          <motion.div
            whileHover={{ y: -1 }}
            transition={{ duration: 0.3 }}
          >
            <Link to="/portfolio" onClick={() => setIsMenuOpen(false)}>Portfolio</Link>
          </motion.div>
          <motion.div
            whileHover={{ y: -1 }}
            transition={{ duration: 0.3 }}
          >
            <Link to="/profil" onClick={() => setIsMenuOpen(false)}>Profil</Link>
          </motion.div>
          <motion.div
            whileHover={{ y: -1 }}
            transition={{ duration: 0.3 }}
          >
            <Link to="/contact" onClick={() => setIsMenuOpen(false)}>Contact</Link>
          </motion.div>
        </nav>
        <button 
          className={`header-menu-toggle ${isMenuOpen ? 'open' : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </motion.header>
  );
}

export default Header;

